<!--
  @description 告警统计
  @author xiehan
  @date 2018/12/17
-->
<template>
  <div class="countAlarm__content">
    <el-form ref="searchForm" :model="searchForm" :inline="true">
      <el-form-item :label="$t('logComponentManage.site')" input-width="auto">
        <g-select :list="siteList" v-model="searchForm.siteCode"></g-select>
      </el-form-item>
      <el-form-item :label="$t('common.time')" input-width="auto">
        <el-form-item prop="startTime">
          <el-date-picker 
            value-format="yyyy-MM-dd" 
            style="width: 180px;" 
            v-model="searchForm.startTime" 
            type="date">
          </el-date-picker>
        </el-form-item>
        <span v-text="$t('common.to')"></span>
        <el-form-item prop="endTime" style="margin-left: 10px">
          <el-date-picker 
            value-format="yyyy-MM-dd"
            style="width: 180px;" 
            v-model="searchForm.endTime" 
            type="date">
          </el-date-picker>
        </el-form-item>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" 
          @click="search"
          v-g-rac="gRac('countAlarm@search')"
          v-text="$t('common.search')"></el-button>
      </el-form-item>
    </el-form>
    <div id="countAlarmChart" :style="chartStyle"></div>
  </div>
</template>

<script>
  import echarts from 'echarts'
  import SiteListBiz from '@/logic/cmdb/cmdbBiz'
  import rac from '@/plugins/rac-mixin'
  import TimeFormat from '@/utils/timeFormat'
  import countAlarmBiz from '@/logic/statistics/countAlarmBiz'
  import EventCenter from '@/utils/eventCenter'
  const eventCenter = EventCenter()

  const CHART_OPTION = {
    color: ['#52B947', '#40C3B3', '#EE9954', '#F27373'],
    xAxis: {
      type: 'category',
      data: [],
      axisLine: {
        show: false
      },
      axisTick: {
        show: false
      }
    },
    yAxis: {
      type: 'value',
      axisLine: {
        show: false
      },
      axisTick: {
        show: false
      }
    },
    legend: {
      data: []
    },
    series: []
  }

  export default {
    mixins: [rac],
    data () {
      return {
        searchForm: {
          startTime: '',
          endTime: '',
          siteCode: ''
        },
        chartStyle: {
          width: '600px',
          height: '400px'
        },
        siteList: {},
        chartInstance: null
      }
    },
    methods: {
      getSiteList () {
        SiteListBiz.siteList({perPageCount: 500}).then((data) => {
          let list = {}
          data.dataList.map((item) => {
            list[item.siteCode] = item.name
          })
          this.siteList = list
          this.searchForm.siteCode = Object.keys(list)[0]
          this.search()
        })
      },
      getToday () {
        let Nowdate = new Date()
        let vYear = Nowdate.getFullYear()
        let vMon = Nowdate.getMonth() + 1
        let vDay = Nowdate.getDate()
        let date = vYear + '-' + vMon + '-' + vDay
        return date
      },
      getLastMonth () {
        let Nowdate = new Date()
        let vYear = Nowdate.getFullYear()
        let vMon = Nowdate.getMonth() + 1
        let vDay = Nowdate.getDate()
        // 每个月的最后一天日期（为了使用月份便于查找，数组第一位设为0）
        let daysInMonth = [0, 31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]
        if (vMon === 1) {
          vYear = Nowdate.getFullYear() - 1
          vMon = 12
        } else {
          vMon = vMon - 1
        }
        // 若是闰年，二月最后一天是29号
        if ((vYear % 4 === 0 && vYear % 100 !== 0) || vYear % 400 === 0) {
          daysInMonth[2] = 29
        }
        if (daysInMonth[vMon] < vDay) {
          vDay = daysInMonth[vMon]
        }
        if (vDay < 10) {
          vDay = '0' + vDay
        }
        if (vMon < 10) {
          vMon = '0' + vMon
        }
        let date = vYear + '-' + vMon + '-' + vDay
        return date
      },
      setOption () {
        CHART_OPTION.xAxis.data = []
        CHART_OPTION.legend.data = [this.$t('countAlarm.prompt'),
          this.$t('countAlarm.common'), this.$t('countAlarm.critical'), this.$t('countAlarm.fatal')]
        CHART_OPTION.series = []
        CHART_OPTION.legend.data.map(item => {
          CHART_OPTION.series.push({
            name: item,
            data: [],
            type: 'bar'
          })
        })
      },
      resize () {
        if (this.chartInstance && !this.chartInstance.isDisposed()) {
          this.chartInstance.resize()
        }
      },
      setChartStyle () {
        this.chartStyle.width = document.getElementsByClassName('tabView')[0].clientWidth - 32 + 'px'
        this.chartStyle.height = document.getElementsByClassName('tabView')[0].clientHeight - 52 - 32 + 'px'
      },
      search () {
        const searchInfo = {
          startTime: TimeFormat.formatTimeTolong(this.searchForm.startTime),
          endTime: TimeFormat.formatTimeTolong(this.searchForm.endTime),
          siteCode: this.searchForm.siteCode
        }
        this.setOption()
        countAlarmBiz.getAlarmCount(searchInfo).then(data => {
          data.data.map(item => {
            CHART_OPTION.xAxis.data.push(item.time)
            CHART_OPTION.series[0].data.push(item['prompt'] ? item['prompt'] : 0)
            CHART_OPTION.series[1].data.push(item['common'] ? item['common'] : 0)
            CHART_OPTION.series[2].data.push(item['critical'] ? item['critical'] : 0)
            CHART_OPTION.series[3].data.push(item['fatal'] ? item['fatal'] : 0)
          })
          this.chartInstance.setOption(CHART_OPTION)
        })
      },
      initEchart () {
        this.chartInstance = echarts.init(document.getElementById('countAlarmChart'))
      },
      setResize () {
        eventCenter.addResizeEvent('countAlarmChart', () => {
          this.setChartStyle()
          this.$nextTick(() => {
            this.resize()
          })
        })
      }
    },
    watch: {
      $route (to, from) {
        if (to.name === 'countAlarm') {
          this.setResize()
        } else if (from.name === 'countAlarm') {
          eventCenter.removeResizeEvent('countAlarmChart')
        }
      }
    },
    mounted () {
      this.searchForm.startTime = this.getLastMonth()
      this.searchForm.endTime = this.getToday()
      this.setChartStyle()
      this.getSiteList()
      this.setResize()
      this.$nextTick(() => {
        this.initEchart()
      })
    }
  }
</script>